/* <og-article>: contents list from the Heading 2s, plus the Quick answer box and FAQ accordion for posts written the old way. */
class OgArticle extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready = true;
    const body = this.querySelector(".ar-b"); if (!body) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

    /* Quick answer written in the body ("Quick answer: ...") becomes the box, unless the field already made one */
    const p = body.querySelector("p");
    if (p && !this.querySelector(".ar-qa")) {
      const st = p.querySelector("strong,b");
      if (st && p.firstElementChild === st && /^\s*quick answer:?\s*$/i.test(st.textContent)) {
        st.remove(); p.removeAttribute("style");
        const box = document.createElement("div"); box.className = "ar-qa";
        const l = document.createElement("b"); l.textContent = this.dataset.quickAnswerLabel || "Quick answer";
        body.parentNode.insertBefore(box, body); box.append(l, p);
      }
    }

    /* FAQ: the last Heading 2 that mentions FAQ or questions, with Heading 3 questions under it, becomes the accordion */
    const faq = this.querySelector(".ar-faq"), faqH = this.querySelector("#ar-faq-h"), list = this.querySelector(".ar-faq-l");
    const fh = [...body.querySelectorAll("h2")].reverse().find((h) => /faq|frequently asked|questions/i.test(h.textContent));
    if (fh && faq) {
      const items = []; let cur = null, n = fh.nextElementSibling; const heads = [];
      while (n && n.tagName !== "H2") {
        const next = n.nextElementSibling;
        if (n.tagName === "H3") { cur = { q: n.textContent.trim(), a: [] }; items.push(cur); heads.push(n); }
        else if (n.tagName !== "SCRIPT" && cur) cur.a.push(n);
        n = next;
      }
      if (items.length > 1) {
        faqH.textContent = fh.textContent.trim();
        items.forEach((it, k) => {
          const w = document.createElement("div"); w.className = "ar-fi";
          w.innerHTML = '<h3><button type="button" class="ar-fq" aria-expanded="' + (k === 0) + '" aria-controls="ar-fa-' + k + '"><span></span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 8h12"/><path class="v" d="M8 2v12"/></svg></button></h3><div class="ar-fa" id="ar-fa-' + k + '" role="region"' + (k === 0 ? "" : " hidden") + "></div>";
          w.querySelector("span").textContent = it.q; w.querySelector(".ar-fa").append(...it.a); list.append(w);
        });
        heads.forEach((x) => x.remove()); fh.remove(); faq.hidden = false;
        list.addEventListener("click", (e) => {
          const b = e.target.closest(".ar-fq"); if (!b) return; const open = b.getAttribute("aria-expanded") === "true";
          list.querySelectorAll(".ar-fq").forEach((o) => { o.setAttribute("aria-expanded", "false"); this.querySelector("#" + o.getAttribute("aria-controls")).hidden = true; });
          if (!open) { b.setAttribute("aria-expanded", "true"); this.querySelector("#" + b.getAttribute("aria-controls")).hidden = false; }
        });
      }
    }

    /* Contents list */
    const toc = this.querySelector(".ar-toc"), ol = toc && toc.querySelector("ol"), hs = [...body.querySelectorAll("h2")];
    if (faq && !faq.hidden) hs.push(faq);
    if (!toc || hs.length < 3) return;
    const ls = hs.map((h) => {
      const t = h === faq ? faqH.textContent : h.textContent.trim();
      if (!h.id) { let s = slug(t) || "section"; while (document.getElementById(s)) s += "-2"; h.id = s; }
      const li = document.createElement("li"), a = document.createElement("a"); a.href = "#" + h.id; a.textContent = t; li.append(a); ol.append(li); return a;
    });
    toc.hidden = false;
    const small = window.matchMedia("(max-width: 980px)");
    const fit = () => { toc.open = !small.matches; }; fit(); small.addEventListener("change", fit);
    ol.addEventListener("click", (e) => {
      const a = e.target.closest("a"); if (!a) return; e.preventDefault(); const h = hs[ls.indexOf(a)]; if (small.matches) toc.open = false;
      h.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" }); history.replaceState(null, "", "#" + h.id);
    });
    let tk = false; const mark = () => { tk = false; let c = -1; hs.forEach((h, i) => { if (h.getBoundingClientRect().top < 160) c = i; });
      ls.forEach((a, i) => { if (i === c) a.setAttribute("aria-current", "true"); else a.removeAttribute("aria-current"); }); };
    this.onScroll = () => { if (!tk) { tk = true; requestAnimationFrame(mark); } };
    window.addEventListener("scroll", this.onScroll, { passive: true }); mark();
  }
  disconnectedCallback() { if (this.onScroll) window.removeEventListener("scroll", this.onScroll); }
}
customElements.define("og-article", OgArticle);
